import { createAxiosInstance } from '@kc-console/core';

import env from '../../utils/env';
import { getTranslationApiFetchers } from './getTranslationApiFetchers';

import type { HttpClientTimingObserver } from '@kc-console/core';

type TranslationApiInstanceReqParams = {
  onHttpTiming?: HttpClientTimingObserver;
  requestId?: string;
  translationEndpoint?: string;
};

const translationApiInstance = (params: TranslationApiInstanceReqParams = {}) => {
  const {
    translationEndpoint = env.KC_TRANSLATION_ENDPOINT || '',
    onHttpTiming,
    requestId,
  } = params;
  const axiosInstance = createAxiosInstance({
    requestId,
    onHttpTiming,
    baseURL: translationEndpoint,
    isCancel: !translationEndpoint,
  });
  return getTranslationApiFetchers(axiosInstance);
};

export default translationApiInstance;
